'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [roomCode, setRoomCode] = useState('');
  const [e2ee, setE2ee] = useState(false);
  const [passphrase, setPassphrase] = useState(randomString(64));

  const startNewMeeting = () => {
    // Role is NOT encoded in the URL. Whoever opens a fresh room first becomes
    // the host — the server decides this from live room state, so a shared link
    // can never hand someone host rights.
    const roomId = generateRoomId();
    if (e2ee) {
      router.push(`/rooms/${roomId}#${encodePassphrase(passphrase)}`);
    } else {
      router.push(`/rooms/${roomId}`);
    }
  };

  const joinMeeting = (e: React.FormEvent) => {
    e.preventDefault();
    const code = roomCode.trim();
    if (code) {
      // The server places the joiner in the waiting room if a host is present.
      router.push(`/rooms/${code}`);
    }
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className={styles.hero}>
        <h1 className={styles.title}>Meet</h1>
        <p className={styles.subtitle}>Secure video meetings for everyone</p>
      </div>

      <div className={styles.card}>
        <button className={`lk-button ${styles.primaryBtn}`} onClick={startNewMeeting}>
          + New meeting
        </button>

        <div className={styles.divider}>or join existing</div>

        <form className={styles.joinForm} onSubmit={joinMeeting}>
          <input
            className={styles.input}
            type="text"
            placeholder="Enter meeting code"
            value={roomCode}
            onChange={(e) => setRoomCode(e.target.value)}
            autoComplete="off"
            spellCheck={false}
          />
          <button className="lk-button" type="submit" disabled={!roomCode.trim()}>
            Join
          </button>
        </form>

        <div className={styles.e2eeSection}>
          <label className={styles.checkboxRow}>
            <input type="checkbox" checked={e2ee} onChange={(ev) => setE2ee(ev.target.checked)} />
            Enable end-to-end encryption
          </label>
          {e2ee && (
            <div className={styles.passphraseRow}>
              <label htmlFor="passphrase">Passphrase</label>
              <input
                id="passphrase"
                className={styles.input}
                type="password"
                value={passphrase}
                onChange={(ev) => setPassphrase(ev.target.value)}
              />
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
